<template>
  <div>

    <v-btn class="red--text" text small dark @click="mostrarDialogo = true">
      <v-icon>mdi-trash-can</v-icon>
    </v-btn>

    <v-dialog v-model="mostrarDialogo" max-width="600px">
      <v-card>
        <v-card-title>
          ¿Eliminar Articulo del Producto?
        </v-card-title>
        <v-card-text class="my-1 font-weight-bold text-subtitle-1 text--primary">
           Articulo: {{ articulo.NOMBRE }}.
        </v-card-text>
        <v-card-actions class="d-flex justify-space-around">
          <v-btn @click="mostrarDialogo=false" class="grey darken-1" dark>Cancelar</v-btn>
          <v-btn @click="eliminarArticulo" class="red" dark>Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
export default {
  props:['articulo'],
  data() {
    return {
      mostrarDialogo:false,
    };
  },

  methods: {
    eliminarArticulo() {
      this.$emit("eliminarArticulo");
    },
  },
};
</script>

<style></style>
